import {useIntl} from 'react-intl';
import React from 'react';
import Waiting from '../../../base-components/StudioWaiting/Waiting';

export const WaitMessage = () => {
  const intl = useIntl();

  return (
    <div className="test-inference-results__full-size-container">
      <Waiting
        diameter={100}
        className="test-inference-results__fetching-streaming-inference-waiting"
        loadingText={
          <>
            <h4>{intl.formatMessage({id: 'test.streamingInferenceLoadingTitle'})}</h4>
            <p className="bodyLargeShort">
              {intl.formatMessage({id: 'test.streamingInferenceLoadingSubTitle'})}
            </p>
          </>
        }
      />
    </div>
  );
};
